export const ALL_ITEM_WINE_AND_SPIRIT = [
    {
      categry: "ecoFriendlyPackaging",
      itemList: [
        {
          itemSelected: "apolline",
          itemName: "Apolline",
          itemDescription:
            "Apolline is our wine box that cherishes your precious vintages.",
            itemDescriptionList: [
              "Made in Thailand Craftsmanship",
              "Variety of World Class Materials",
              "Professional Consultation",
              "Fast Delivery",
            ],
          itemDesktopBig: [
            "/images/listItem/customizedProjects/WineandSpirits/Desktop/Apolline/700x700px/lussopack-winepackaging-apolline-01.webp",          
            "/images/listItem/customizedProjects/WineandSpirits/Desktop/Apolline/700x700px/lussopack-winepackaging-apolline-02.webp",                  
          ],
          itemDesktopSmall: [
            "/images/listItem/customizedProjects/WineandSpirits/Desktop/Apolline/130x130px/lussopack-winepackaging-apolline-01.webp",
            "/images/listItem/customizedProjects/WineandSpirits/Desktop/Apolline/130x130px/lussopack-winepackaging-apolline-02.webp",
          ],
          itemMobileBig: [
            "/images/listItem/customizedProjects/WineandSpirits/Mobile/Apolline/335x335px/lussopack-winepackaging-apolline-01.webp",
            "/images/listItem/customizedProjects/WineandSpirits/Mobile/Apolline/335x335px/lussopack-winepackaging-apolline-02.webp",
          ],
          itemMobileSmall: [
            "/images/listItem/customizedProjects/WineandSpirits/Mobile/Apolline/100x100px/lussopack-winepackaging-apolline-01.webp",
            "/images/listItem/customizedProjects/WineandSpirits/Mobile/Apolline/100x100px/lussopack-winepackaging-apolline-02.webp",
          ],
        },
        {
          itemSelected: "olivia",
          itemName: "Olivia",
          itemDescription:
            "Olivia is our wine and spirits packaging which we can customize to meet your needs.",
            itemDescriptionList: [
              "Made in Thailand Craftsmanship",
              "Variety of World Class Materials",
              "Professional Consultation",
              "Fast Delivery",
            ],
          itemDesktopBig: [
            "/images/listItem/customizedProjects/WineandSpirits/Desktop/Olivia/700x700px/lussopack-winepackaging-olivia-01.webp",
            "/images/listItem/customizedProjects/WineandSpirits/Desktop/Olivia/700x700px/lussopack-winepackaging-olivia-02.webp",          
            "/images/listItem/customizedProjects/WineandSpirits/Desktop/Olivia/700x700px/lussopack-winepackaging-olivia-03.webp",          
            "/images/listItem/customizedProjects/WineandSpirits/Desktop/Olivia/700x700px/lussopack-winepackaging-olivia-04.webp",          
            "/images/listItem/customizedProjects/WineandSpirits/Desktop/Olivia/700x700px/lussopack-winepackaging-olivia-05.webp",             
          ],
          itemDesktopSmall: [
            "/images/listItem/customizedProjects/WineandSpirits/Desktop/Olivia/130x130px/lussopack-winepackaging-olivia-01.webp",
            "/images/listItem/customizedProjects/WineandSpirits/Desktop/Olivia/130x130px/lussopack-winepackaging-olivia-02.webp",          
            "/images/listItem/customizedProjects/WineandSpirits/Desktop/Olivia/130x130px/lussopack-winepackaging-olivia-03.webp",          
            "/images/listItem/customizedProjects/WineandSpirits/Desktop/Olivia/130x130px/lussopack-winepackaging-olivia-04.webp",          
            "/images/listItem/customizedProjects/WineandSpirits/Desktop/Olivia/130x130px/lussopack-winepackaging-olivia-05.webp",             
          ],
          itemMobileBig: [
            "/images/listItem/customizedProjects/WineandSpirits/Mobile/Olivia/335x335px/lussopack-winepackaging-olivia-01.webp",
            "/images/listItem/customizedProjects/WineandSpirits/Mobile/Olivia/335x335px/lussopack-winepackaging-olivia-02.webp",          
            "/images/listItem/customizedProjects/WineandSpirits/Mobile/Olivia/335x335px/lussopack-winepackaging-olivia-03.webp",          
            "/images/listItem/customizedProjects/WineandSpirits/Mobile/Olivia/335x335px/lussopack-winepackaging-olivia-04.webp",          
            "/images/listItem/customizedProjects/WineandSpirits/Mobile/Olivia/335x335px/lussopack-winepackaging-olivia-05.webp",             
          ],
          itemMobileSmall: [
            "/images/listItem/customizedProjects/WineandSpirits/Mobile/Olivia/100x100px/lussopack-winepackaging-olivia-01.webp",
            "/images/listItem/customizedProjects/WineandSpirits/Mobile/Olivia/100x100px/lussopack-winepackaging-olivia-02.webp",          
            "/images/listItem/customizedProjects/WineandSpirits/Mobile/Olivia/100x100px/lussopack-winepackaging-olivia-03.webp",          
            "/images/listItem/customizedProjects/WineandSpirits/Mobile/Olivia/100x100px/lussopack-winepackaging-olivia-04.webp",          
            "/images/listItem/customizedProjects/WineandSpirits/Mobile/Olivia/100x100px/lussopack-winepackaging-olivia-05.webp",             
          ],
        },
      ],
    },
  ];
  